import { useNavigate } from "react-router-dom";

export default function PoshLogo() {
  const navigate = useNavigate();
  return (
    <div onClick={() => navigate("/")}>
      <h1 className="text-4xl font-bold text-yellow-600 font-Play">POSH</h1>
    </div>
  );
}
